import { UseWebsocketQueryOptions, WebsocketSubscription } from '@/hooks/query-hooks/websockets';
import { GaiaQueryWithAgentId, QueryToast } from '@/queries/types';
import { LatestValue } from '@/types/reading-types';

export interface Reading extends WebsocketSubscription {
  latestValue?: LatestValue;
}

export const readingsStreamQuery = ({
  agentId,
}: GaiaQueryWithAgentId): UseWebsocketQueryOptions<Reading[] | null> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'readings'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/agents/${agentId}/readings-stream`,
  };
};
